const LoaderConstants = {
  PRESERVE_ASPECT: "xMidYMid slice",
  TRUE: true,
  FALSE: false
}

export default LoaderConstants